module.exports = __webpack_public_path__ + "static/img/floorBanner.fc6eced7.png";